package org.mkui.graphics

import com.macrofocus.common.collection.CollectionFactory.copyOnWriteArrayList

abstract class AbstractIDrawing : IDrawing {
    private val listeners: MutableList<IDrawingListener> = copyOnWriteArrayList()
    override val isActive: Boolean
        get() = true

    override fun addIDrawingListener(listener: IDrawingListener) {
        listeners.add(listener)
    }

    override fun removeIDrawingListener(listener: IDrawingListener) {
        listeners.remove(listener)
    }

    protected open fun notifyIDrawingChanged() {
        for (listener in listeners) {
            listener.iDrawingChanged()
        }
    }
}
